module.exports = __webpack_public_path__ + "10de3d014b77216e1e16ad0e0e07de7e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/flask-orange.png
// module id = 3002
// module chunks = 0